import Vue from 'vue';
import en from './en.js';
import fr from './fr.js';

const translations = { fr, en };
const locale = Vue.observable({ value: 'en' });

const t = (path) => {
    const pathParts = path.split('.');
    let current = translations[locale.value];
    let value = '';

    for (let i = 0, j = pathParts.length; i < j; i++) {
        const part = pathParts[i];
        value = current[part];

        if (i === j - 1) {
            return value;
        }

        if (!value) {
            return '';
        }

        current = value;
    }

    return '';
};

const use = newLocale => {
    locale.value = newLocale || locale.value;
};

export { t, use, locale };
export default { t, use, locale };
